export default __webpack_public_path__ + "static/media/s.b6747260.mp3";